<template lang="pug">
div
  el-card(shadow="hover")
    app-divider(label="Informações para emissão do DAR: ", :addMarginTop="false").margin-bottom
    div.center
      el-col(:span='8').flex
        app-display(label="Prestação (PMT):", :content="parcela.numero" :contentAlignRight="true")
        app-display(label="Quantidade de DARs emitidos:", content="0", :contentAlignRight="true")
        app-display(label="Tipo de pagamento:", content="À prazo", :contentAlignRight="true")
        app-display(label="Situação de VTN:", content="Em aberto", toolTip="left-end", :contentAlignRight="true")
        app-display(label="Data de Vencimento:", :content="parcela.dataVencimentoFormatada", toolTip="left-end", :contentAlignRight="true")
      el-col(:span='8').flex
        app-display(label="Valor inicial da Prestação (PMT):", :content="parcela.valorFormatado", :contentAlignRight="true")
        app-display(label="Total de Correção anual:", :content="parcela.correcaoFormatada", :contentAlignRight="true")
        app-display(label="Total de Juros:", :content="parcela.jurosFormatado", :contentAlignRight="true")
        app-display(label="Amortização:", :content="parcela.amortizacaoFormatada", :contentAlignRight="true")
        app-display(label="Valor total do DAR:", :content="parcela.valorFormatado", :contentAlignRight="true")
</template>

<script>
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  components: {
    AppDisplay,
    AppDivider
  },

  props: {
    parcela: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      dadosEmissaoDAR: {
        prestacao: '',
        qtdDarEmitido: '',
        tipoPagamento: '',
        situacaoVtn: '',
        dataVencimento: '',
        valorInicialPrestacao: '',
        totalCorrecao: '',
        totalJuros: '',
        amortizacao: '',
        valorTotalDar: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 13%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/InformacoesDar.vue